import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import colors from 'common/styles/colors';

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 13px;
  color: ${colors.black};
  &:hover {
    background: ${colors.greyXL};
  }
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const Icon = styled.span`
  font-size: 14px;
  opacity: 0.7;
`;

const Name = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${props => props.$color || colors.greyD};
`;

function conditionDot(condition) {
  const c = condition != null ? Number(condition) : null;
  if (c === 1) return colors.green;
  if (c === 2) return colors.warning;
  if (c === 3) return colors.critical;
  return colors.greyD;
}

export default function SensorsPanel({ sensors, loading }) {
  const { t } = useTranslation();
  if (loading) {
    return (
      <div style={{ padding: '12px 8px', color: '#888', fontSize: 13 }}>
        {t('digitalTwin.loadingSensors')}
      </div>
    );
  }
  if (!sensors || !sensors.length) {
    return (
      <div style={{ padding: '12px 8px', color: '#888', fontSize: 13, lineHeight: 1.5 }}>
        {t('digitalTwin.noSensorsAssigned')}
      </div>
    );
  }
  return (
    <div>
      {sensors.map((s, idx) => (
        <Row key={s.id != null ? s.id : `sensor-${idx}`}>
          <Left>
            <Icon aria-hidden>〰</Icon>
            <Name title={s.name}>{s.name}</Name>
          </Left>
          <Dot $color={conditionDot(s.condition)} />
        </Row>
      ))}
    </div>
  );
}
